"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSubsectionContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("assets/styles/config");
exports.StyledSubsectionContainer = styled_components_1.default.div `
  align-items: center;
  border-bottom: 1px solid ${config_1.colors.pavement};
  display: flex;
  filter: blur(0);
  flex-direction: ${(props) => (props.vertical ? 'column' : 'row')};
  height: ${(props) => (props.height ? props.height : '440px')};
  justify-content: space-between;
  margin: ${(props) => (props.header ? '0' : '0 25px')};
  padding: ${(props) => (props.header ? '0 25px' : '0')};

  &:last-child {
    border: none;
    margin: 0;
    padding: 0 25px;
  }
`;
